/**
 * AI 分析 - 推荐决策卡片
 */
import React from 'react';
import { Card, Row, Col, Typography, Progress } from 'antd';
import {
  CheckCircleOutlined,
  WarningOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

interface Recommendation {
  decision: string;
  score: number;
  brief: string;
}

interface AIRecommendationProps {
  recommendation: Recommendation;
}

export const AIRecommendation: React.FC<AIRecommendationProps> = ({ recommendation }) => {
  const getDecisionIcon = (decision: string) => {
    switch (decision) {
      case '推荐进入':
        return <CheckCircleOutlined style={{ color: '#52c41a' }} />;
      case '谨慎考虑':
        return <WarningOutlined style={{ color: '#faad14' }} />;
      case '不推荐':
        return <CloseCircleOutlined style={{ color: '#ff4d4f' }} />;
      default:
        return null;
    }
  };

  const getScoreColor = (score: number) => {
    if (score >= 70) return '#52c41a';
    if (score >= 40) return '#faad14';
    return '#ff4d4f';
  };

  return (
    <Card className="ai-decision-card">
      <Row gutter={[24, 16]} align="middle">
        <Col xs={24} sm={3} className="ai-decision-icon">
          {getDecisionIcon(recommendation.decision)}
        </Col>
        <Col xs={24} sm={15}>
          <Title level={3} style={{ margin: 0, color: '#262626' }}>
            {recommendation.decision}
          </Title>
          <Paragraph style={{ margin: '12px 0 0 0', fontSize: '15px', color: '#595959' }}>
            {recommendation.brief}
          </Paragraph>
        </Col>
        <Col xs={24} sm={6} className="ai-decision-score">
          <Progress
            type="circle"
            percent={recommendation.score}
            size={90}
            strokeLinecap="round"
            strokeColor={getScoreColor(recommendation.score)}
          />
          <Text type="secondary" style={{ marginTop: 12, fontSize: '13px' }}>
            综合评分
          </Text>
        </Col>
      </Row>
    </Card>
  );
};

